import { useTimesheetStore, BreakState } from '@/stores/timesheets';
import { editBreakState } from './editBreakState';
import { Slots } from '@/lib/request/types/timesheet';
import { dateToSeconds, isoDateToSeconds } from '@/lib/util/dateTime';

export function checkEmptyFields(newStartTime: any, newEndTime: any) {
  return (
    !newStartTime.data?.hh ||
    !newStartTime.data?.mm ||
    !newStartTime.data?.a ||
    !newEndTime.data?.hh ||
    !newEndTime.data?.mm ||
    !newEndTime.data?.a
  );
}

export function isBreakOverlapping(
  currentBreak: Slots | null,
  allBreaks: Slots[],
  state: any
) {
  const timesheets = useTimesheetStore();

  const shiftStartTime = isoDateToSeconds(timesheets.getStartShiftTime());

  if (!state.break.startTime.data) {
    if (editBreakState.addBreakForm) {
      editBreakState.emptyField = true;
    }
    return false;
  } else if (checkEmptyFields(state.break.startTime, state.break.endTime)) {
    editBreakState.emptyField = true;
    return false;
  }

  const MILLISECONDS_IN_SECOND = 1000;
  let isOverlapping = false;
  editBreakState.emptyField = false;

  const breakStartTime =
    dateToSeconds(
      state.break.startDate.getFullYear(),
      state.break.startDate.getMonth() + 1,
      state.break.startDate.getDate(),
      state.break.startTime.data.HH,
      state.break.startTime.data.mm
    ) - shiftStartTime;
  const breakEndTime =
    dateToSeconds(
      state.break.endDate.getFullYear(),
      state.break.endDate.getMonth() + 1,
      state.break.endDate.getDate(),
      state.break.endTime.data.HH,
      state.break.endTime.data.mm
    ) - shiftStartTime;

  if (!allBreaks.length) {
    return (
      breakStartTime < 0 ||
      breakEndTime >= Date.now() / MILLISECONDS_IN_SECOND - shiftStartTime ||
      breakStartTime >= breakEndTime
    );
  }

  allBreaks.forEach((breakItem: Slots) => {
    if (isOverlapping || breakItem.strState !== BreakState.Finished) {
      if (editBreakState.addBreakForm) {
        isOverlapping =
          breakStartTime >= breakEndTime ||
          breakStartTime < 0 ||
          breakEndTime >= Date.now() / MILLISECONDS_IN_SECOND - shiftStartTime;
      }
      return;
    }

    const breakItemStartTime = breakItem.intUnixStart - shiftStartTime;
    const breakItemEndTime = breakItem.intUnixEnd - shiftStartTime;

    if (currentBreak != breakItem) {
      isOverlapping =
        (breakItemStartTime <= breakStartTime &&
          breakStartTime <= breakItemEndTime) ||
        (breakItemStartTime <= breakEndTime &&
          breakEndTime <= breakItemEndTime) ||
        (breakStartTime <= breakItemStartTime &&
          breakEndTime >= breakItemEndTime) ||
        breakStartTime >= breakEndTime ||
        breakStartTime < 0 ||
        breakEndTime >= Date.now() / MILLISECONDS_IN_SECOND - shiftStartTime;
    } else {
      isOverlapping =
        breakStartTime >= breakEndTime ||
        breakStartTime < 0 ||
        breakEndTime >= Date.now() / MILLISECONDS_IN_SECOND - shiftStartTime;
    }
  });

  return isOverlapping;
}

export function isEndTimeOverlappingBreak(
  allBreaks: Slots[],
  newEndTime: any,
  newEndDate: any
) {
  const timesheets = useTimesheetStore();

  const shiftStartTime = isoDateToSeconds(timesheets.getStartShiftTime());

  let isOverlapping = false;

  if (!newEndTime.data) {
    return false;
  }

  allBreaks.forEach((breakItem: Slots) => {
    if (isOverlapping || breakItem.strState !== BreakState.Finished) {
      return;
    }

    const shiftEndTime =
      dateToSeconds(
        newEndDate.getFullYear(),
        newEndDate.getMonth() + 1,
        newEndDate.getDate(),
        newEndTime.data.HH,
        newEndTime.data.mm
      ) - shiftStartTime;

    const breakItemEndTime = breakItem.intUnixEnd - shiftStartTime;

    isOverlapping = shiftEndTime <= breakItemEndTime;
  });

  return isOverlapping;
}

export function isStartTimeOverlappingBreak(
  allBreaks: Slots[],
  newStartTime: any,
  newStartDate: any
) {
  const timesheets = useTimesheetStore();

  const shiftStartTime = isoDateToSeconds(timesheets.getStartShiftTime());

  let isOverlapping = false;

  if (!newStartTime.data) {
    return false;
  }

  allBreaks.forEach((breakItem: Slots) => {
    if (isOverlapping || breakItem.strState !== BreakState.Finished) {
      return;
    }

    const shiftNewStartTime =
      dateToSeconds(
        newStartDate.getFullYear(),
        newStartDate.getMonth() + 1,
        newStartDate.getDate(),
        newStartTime.data.HH,
        newStartTime.data.mm
      ) - shiftStartTime;

    const breakItemStartTime = breakItem.intUnixStart - shiftStartTime;

    isOverlapping = shiftNewStartTime > breakItemStartTime;
  });

  return isOverlapping;
}
